import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import * as fromStore from 'src/app/_store/_reducers';
import { WelcomeParameters } from 'src/app/_shared/interface/welcome-parameters.interface';
import { UserActions } from 'src/app/_store/_user/actions';

@Component({
  selector: 'app-welcome-dialog',
  templateUrl: './welcome-dialog.component.html',
  styleUrls: ['./welcome-dialog.component.scss'],
})
export class WelcomeDialogComponent {
  isAdminEngineer: boolean;
  firstName: string;

  constructor(
    public dialogRef: MatDialogRef<WelcomeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: WelcomeParameters,
    private store: Store<fromStore.State>
  ) {
    this.isAdminEngineer = data.isAdminEngineer;
    this.firstName = data.firstName;
  }

  closeDialog(): void {
    this.store.dispatch(
      UserActions.updateUserPreferences({
        payload: { property: { welcomeMessage: false } },
      })
    );
    this.dialogRef.close();
  }
}
